import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { IDataMergeViewModel } from "services/api/types";
import { MergeConflictsTable } from "./MergeConflictsTable";
import Typography from "@mui/material/Typography";
import { paths } from "routes/Paths";
import { Link } from "react-router-dom";

type Props = {
  dataMerge: IDataMergeViewModel;
  useDiscardedValue: (mergeActionId: string) => Promise<void>;
};

const DataMerge = (props: Props) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {},
      descriptionLabel: {
        display: "inline-block",
        marginRight: theme.spacing(2),
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
      },
    })
  );

  const classes = useStyles();

  const renderMergeTargetLink = () => {
    if (props.dataMerge.type === "Company") {
      return (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={`${paths.app.admin.companyDetails}/${props.dataMerge.companyId}/overview`}
        >
          View Merged Company
        </Link>
      );
    } else {
      return (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={`${paths.app.admin.companyDetails}/${props.dataMerge.companyId}/contacts/${props.dataMerge.keptEntityId}`}
        >
          View Merged Contact
        </Link>
      );
    }
  };

  const renderHeader = () => {
    return (
      <Typography className={classes.header}>
        <strong>{props.dataMerge.description}</strong>
        {renderMergeTargetLink()}
      </Typography>
    );
  };

  return (
    <div className={classes.root}>
      {renderHeader()}
      <MergeConflictsTable
        dataMergeType={props.dataMerge.type}
        useDiscardedValue={props.useDiscardedValue}
        mergeConflicts={props.dataMerge.conflicts}
      />
    </div>
  );
};

export { DataMerge };
